exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pt10 {\n  padding-top: 1rem !important;\n}\n.ui.secondary.menu .active.item,\n.ui.secondary.menu .item {\n  border-right: none !important;\n}\n.disabled.field {\n  background: transparent !important;\n}\n.linkCss {\n  padding: 0.78571429em 1.5em 0.78571429em;\n}\n.floatRight {\n  float: right;\n}\n.bidPriceItemName {\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 0.9em;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.itemGridDropdown {\n  width: 230px;\n  position: absolute !important;\n}\n.pt-50 {\n  padding-top: 50px !important;\n}\n.labelClass {\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 0.78571429em;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding-top: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/inventory/itemmaintenance/index.less
// module id = 3321
// module chunks = 0